import { render, staticRenderFns } from "./MarketingPlanAccess.vue?vue&type=template&id=2de54d8c&scoped=true"
import script from "./MarketingPlanAccess.vue?vue&type=script&lang=js"
export * from "./MarketingPlanAccess.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlanAccess.vue?vue&type=style&index=0&id=2de54d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de54d8c",
  null
  
)

export default component.exports